<template>
  <div>
    <el-form
            ref="searchForm"
            :model="searchData"
            inline
    >
      <el-form-item label="身份证号">
        <el-input
                v-model="searchData.idcard_number"
                size="mini"
        />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchData.status" placeholder="请选择">
          <el-option
                  v-for="item in statusOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="所属公司">
        <!-- <el-input v-model="dataSetVerify.company" size="mini" /> -->
        <el-select v-model="searchData.company" placeholder="请选择">
          <el-option
                  v-for="item in companyOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button
                size="mini"
                @click="handlerSearch"
        >
          查找
        </el-button>
      </el-form-item>
    </el-form>


    <el-table :data="AgentVerfiyList" v-loading="loading">
      <el-table-column prop="id" label="ID" />
      <el-table-column prop="user_id" width="70px" label="user_id">
        <template slot-scope="scope">
          <el-link
            :href="'#/agent/VerifyLogList/' + scope.row.user_id"
            type="primary"
            target="_blank"
          >{{ scope.row.user_id }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="user_id" width="50px">
        <template slot-scope="s">
          <el-image :src="s.row.avatar || ''" style="width: 40px; height: 40px;" />
        </template>
      </el-table-column>
      <el-table-column prop="nickname" label="微信昵称">
        <template slot-scope="scope">
          <el-link
            :href="'#/agent/detail/' + scope.row.user_id"
            type="primary"
            target="_blank"
          >{{ scope.row.nickname }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" :formatter="statusFormatter"/>
      <el-table-column label="所属公司">
        <template slot-scope="scope">
          {{ companyOptionsData[scope.row.company] }}
        </template>
      </el-table-column>
      <el-table-column prop="idcard_name"  width="120px" label="姓名" />
      <el-table-column prop="idcard_number" width="200px" label="身份证号" />
      <el-table-column label="性别">
        <template slot-scope="scope">
          {{ getGender(scope.row.idcard_number) }}
        </template>
      </el-table-column>
      <el-table-column prop="apply_time" width="150px" label="申请时间" />
      <el-table-column prop="verify_time" width="150px" label="处理时间" />

      <el-table-column prop="id" label="操作" width="180px">
        <template slot-scope="scope">
          <el-button type="info" v-if="scope.row.status == 0" size="mini" @click="handleVerifyUser(scope.row.user_id)">通过</el-button>
          <el-button type="info" v-if="scope.row.status == 0" size="mini" @click="handleRefuseUser(scope.row.user_id)">拒绝</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog :visible.sync="showRefuseVerify">
      <el-form ref="searchForm" :model="dataRefuseVerify">
        <el-form-item label="拒绝原因">
          <el-select v-model="dataRefuseVerify.refusal_reasons_select" placeholder="拒绝原因"  @change=reason_text()>
            <el-option label="该用户不存在或姓名\证件号错误" value="该用户不存在或姓名\证件号错误"></el-option>
            <el-option label="该用户已离职" value="该用户已离职"></el-option>
            <el-option label="其他" value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="拒绝描述">
          <el-input v-model="dataRefuseVerify.refusal_reasons" class="textarea" />
        </el-form-item>

        <el-form-item>
          <el-button type="success" size="mini" @click="subRefuseVerify()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="showSetVerify">
      <div class = "content-left">
        <el-row>
          <div 
            v-for="(item, index) in dataInfo"
            :key="index"
          >{{item.title}}: {{item.value}}</div>
        </el-row>
      </div>
      <el-form ref="searchForm" :model="dataSetVerify">
        <el-form-item label="资格证书号码">
          <el-input v-model="dataSetVerify.certificate_num" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="资格证书类型">
          <el-input v-model="dataSetVerify.certificate_type" size="mini" />
        </el-form-item>
        <el-form-item label="执业证编号">
          <el-input v-model="dataSetVerify.licensed_num" size="mini" />
        </el-form-item>
        <el-form-item label="执业证状态">
          <el-input v-model="dataSetVerify.licensed_status" size="mini" />
        </el-form-item>
        <el-form-item label="业务范围">
          <el-input v-model="dataSetVerify.scope" size="mini" />
        </el-form-item>
        <el-form-item label="执业区域">
          <el-input v-model="dataSetVerify.area" size="mini" />
        </el-form-item>
        <el-form-item label="认证公司">
          <el-input v-model="dataSetVerify.verify_company" size="mini" />
        </el-form-item>
        <el-form-item label="所属公司">
          <!-- <el-input v-model="dataSetVerify.company" size="mini" /> -->
          <el-select v-model="dataSetVerify.company" placeholder="请选择">
            <el-option
              v-for="item in companyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="success" size="mini" @click="subVerify()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <page-bar :currentPageCount="AgentVerfiyList.length" @page-changed="loadData"></page-bar>
  </div>
</template>
<style>
.content-left {
  text-align : left
}
</style>
<script>
import PageBar from "../ui/PageBar";
import request from "../../api/request";
import { pick, keys, map } from "lodash";

export default {
  name: "AgentVerfiyList",
  components: {
    PageBar
  },
  data() {
    return {
      AgentVerfiyList: [],
      loading: false,
      dataSetVerify: {},
      dataRefuseVerify: {
        'user_id':'',
        'refusal_reasons_select':'',
        'refusal_reasons':''
      },
      showReward: false,
      showRefuseVerify: false,
      showSetVerify: false,
      dataInfo: [],
      companyOptions: [],
      searchData:{},
      filter: {},
      statusOptions: [{
        value: '',
        label: '请选择'
      },{
        value: 0,
        label: '待审核'
      } , {
        value: 1,
        label: '通过'
      }, {
        value: 2,
        label: '拒绝'
      }],
      companyOptionsData:{}
    };
  },
  async created() {
    this.loadData([0, 10]);
    let resp = await request.product.post("get_doc_define", {
      category: "verify_company"
    });
    if (resp.status === 0) {
      this.companyOptionsData = resp.data,
      this.companyOptions = map(resp.data, (value, key) => {
          return {
            label: value,
            value: key
          };
        }
      );
      let tmp = [{
        value: "",
        label: '请选择'
      }]
      this.companyOptions = tmp.concat(this.companyOptions)
      //console.log(this.companyOptions);
      //this.companyOptions= resp['data'];
    }
  },
  methods: {
    statusFormatter(row, column, cellValue) {
      return ['待审核', '通过', '拒绝'][cellValue]
    },
    async loadData(range) {
      request.agent
        .post("verify_get_list", {
          filter: this.filter,
          range: range,
          sort: [{ field: "id", reverse: true }]
        })
        .then(r => {
          this.AgentVerfiyList = r.data.list;
          this.loading = false;
        });
    },
    handleRefuseUser: function(id) {
      this.getVerifyInfo(id);
      this.showRefuseVerify = true;
      this.dataRefuseVerify.user_id = id;
    },
    handleVerifyUser: function(id) {
      this.getVerifyInfo(id);
      this.showSetVerify = true;
      this.dataSetVerify.user_id = id;
    },
    subVerify: function() {
//      console.log(this.dataSetVerify.user_id);

      request.agent
        .post("verify_set_agent", {
          user_id: this.dataSetVerify.user_id,
          status: 1,
          company: this.dataSetVerify.company + "",
          certificate_num: this.dataSetVerify.certificate_num + "",
          certificate_type: this.dataSetVerify.certificate_type + "",
          licensed_num: this.dataSetVerify.licensed_num + "",
          licensed_status: this.dataSetVerify.licensed_status + "",
          scope: this.dataSetVerify.scope + "",
          area: this.dataSetVerify.area + "",
          verify_company: this.dataSetVerify.verify_company + ""
        })
        .then(() => {
          this.$message.success("通过审核");
        })
        .finally(() => {
          this.showSetVerify = false;
          this.dataSetVerify = {};
          location.reload();
        });
    },
    subRefuseVerify: function() {
      request.agent
        .post("verify_set_agent", {
          user_id: this.dataRefuseVerify.user_id,
          status: 2,
          refusal_reasons_select:
            this.dataRefuseVerify.refusal_reasons_select + "",
          refusal_reasons: this.dataRefuseVerify.refusal_reasons + ""
        })
        .then(() => {
          this.$message.success("拒绝通过");
        })
        .finally(() => {
          this.showRefuseVerify = false;
          this.dataRefuseVerify = {};
          location.reload();
        });
    },
    getVerifyInfo: async function(id) {
      const resp = await request.agent.post("verify_get_info", {
        user_id: id
      });
      if (resp.status === 0) {
        const nameMapping = {
          user_id: "uid",
          idcard_name: "姓名",
          gender:"性别",
          idcard_number: "身份证号"
        };
        var idcard_number = resp["data"]['idcard_number'];
        resp["data"]['gender'] = this.getGender(idcard_number);
        // this.dataInfo= resp['data'];
        this.dataInfo = map(
          pick(resp["data"], keys(nameMapping)),
          (value, key) => {
            return {
              title: nameMapping[key],
              value
            };
          }
        );
        // console.log(this.dataInfo);
      }
    },
    getGender(idcard){
      return ['女','男'][idcard.slice(-2, -1) % 2];
    },
    handlerSearch: function() {
      let filter = {}
      if (this.searchData.idcard_number) {
        filter.idcard_number = this.searchData.idcard_number
      }
      if (this.searchData.status !== '') {
        filter.status = this.searchData.status
      }
      if (this.searchData.company) {
        filter.company = this.searchData.company
      }

      console.log(filter)
      this.filter = filter
      this.loadData([0, 10]);
    },
    reason_text: function() {
      this.dataRefuseVerify.refusal_reasons = this.dataRefuseVerify.refusal_reasons_select
    },
  }
};
</script>